import React, {useContext, useEffect, useState} from "react";
import {
    isAuthenticatedContext,
    userInfosContext,
} from "../../contexts/authContext";
import {logout} from "../../utils/authApi";
import "./Nav.css";

const Nav = () => {
    const [toggleMenu, setToggleMenu] = useState(false);

    const toggleMenuRes = () => {
        setToggleMenu(!toggleMenu);
    };

    const handleDisconnect = () => {
        logout();
        setIsAuthenticated(false);
        window.location = "/";
    };

    // const resetMenu = () => {
    //     toggleMenu = false;
    // }
    // onMount(() => {
    //     const mediaListener = window.matchMedia("(max-width: 650px)");
    //     mediaListener.addListener(resetMenu);
    // })

    const [isAuthenticated, setIsAuthenticated] = useState(
        useContext(isAuthenticatedContext)
    );
    const userInfos = useContext(userInfosContext);

    useEffect(()=> {
        if (toggleMenu===true) {
            document.querySelector("html").style.overflow = 'hidden';
        }else {
            document.querySelector("html").style.overflow = 'auto';

        }
    })

    return (
        <nav>
            <a className="brand" href="/">
                <img className="icon" src="assets/fabriklogo.svg" alt="icon"/>
            </a>

            <div onClick={toggleMenuRes} className={toggleMenu ? "btn11 active" : "btn11"}>
                <div className="ligneUnique"/>
            </div>


            <div className={toggleMenu ? "list-nav visible" : "list-nav "}>
                <ul>
                    <li >
                        <a href="https://www.google.fr/maps/place/110+Rue+des+Postes,+59000+Lille/@50.6249309,3.0529814,17z/data=!3m1!4b1!4m5!3m4!1s0x47c2d59c0c42f181:0x80afa29201e43e4a!8m2!3d50.6249275!4d3.0551701" target="_blank">Adresse</a>
                        <img className="icons-links" src="assets/place_white_24dp.svg" alt="icons"/>
                    </li>
                    <li >
                        <a href="mailto:burgerfabrik@gmail.com?subject=Mail depuis le site internet">Mail</a>
                        <img className="icons-links" src="assets/email_white_24dp.svg" alt=""/>
                    </li>
                    <li >
                        <a href="https://www.ubereats.com/fr/lille/food-delivery/fabrik-burger/dMUlWAS8TGiOKDMY5ZCinA">Uber Eat</a>
                        <img className="icons-links" src="assets/ubereats.png" alt=""  width={50}/>

                    </li>
                    <li >
                        <a href="https://deliveroo.fr/fr/menu/lille/lille-wazemmes/fabrik-burger">Deliveroo</a>
                        <img className="icons-links" src="assets/deliveroo-1.svg" alt=""  width={60}/>

                    </li>

                </ul>
            </div>


            {/*{isAuthenticated ? (*/}
            {/*    <li className="items-nav">*/}
            {/*        <a href="#" onClick={handleDisconnect}>*/}
            {/*            Deconnexion*/}
            {/*        </a>*/}
            {/*    </li>*/}
            {/*) : (*/}
            {/*    <li className="items-nav">*/}
            {/*        <a href="/profil">Connexion</a>*/}
            {/*    </li>*/}
            {/*)}*/}
            {/*{userInfos.username !== "Pseudo" ? (*/}
            {/*    <li className="items-nav">*/}
            {/*        <a href="#">{userInfos.username}</a>*/}
            {/*    </li>*/}
            {/*) : (*/}
            {/*    ""*/}
            {/*)}*/}


        </nav>
    );
};

export default Nav;
